/**
 * Корень приложения: поверхность продукта — Astra.
 *
 * Здесь собираются провайдеры, а адреса живут в ОДНОЙ таблице
 * (`astra/App.tsx`). Прежний каркас каноники (`components/AppShell` и его
 * дерево маршрутов) заменён каркасом Astra: сайдбар, топбар и полоса контекста
 * («цикл · дата · массив · хозяйство · демо») приехали кодом прототипа, а не
 * были перерисованы. Экраны каноники не удалены: `/registry`, `/data-quality`
 * и `/data-map` стоят разделом «Данные» и отвечают на вопрос, которого у Astra
 * нет, — как собран канон и что в него не вошло. Там же, на канонических
 * маршрутах, оболочка показывает полосу контекста: две оси среза (`as_of` и
 * `include_demo`) задаются только там, где они что-то значат.
 *
 * Порядок провайдеров не косметический:
 *
 * * `AnalysisContextProvider` — срез и «показывать ли демо»: права
 *   разрешаются на дату контекста, поэтому он самый внешний;
 * * `AuthProvider` — кто вошёл (`/auth/me`); от него зависит персона Astra;
 * * `TrackProvider` — набор фикстур (A/B). Переключатель треков остаётся
 *   только внутри режима `fixtures` и уйдёт вместе с последним таким экраном;
 * * `RoleProvider` — персона интерфейса, выведенная из роли канона;
 * * `DataSourceProvider` — источник данных текущего маршрута.
 */

import { AnalysisContextProvider } from "./analysis/context";
import { AuthProvider } from "./auth/context";
import { AppRoutes } from "./astra/App";
import { RoleProvider } from "./astra/auth/RoleContext";
import { TrackProvider } from "./astra/data/TrackContext";
import { DataSourceProvider } from "./astra/data-source/provider";
import "./astra/styles/global.css";
import "./astra/ui/ui.css";
import "./styles/tailwind.css";

export function App() {
  return (
    <AnalysisContextProvider>
      <AuthProvider>
        <TrackProvider>
          <RoleProvider>
            <DataSourceProvider>
              <AppRoutes />
            </DataSourceProvider>
          </RoleProvider>
        </TrackProvider>
      </AuthProvider>
    </AnalysisContextProvider>
  );
}
